import { Card, CardContent } from '@/components/ui/card';
import { Shield, Search, CheckCircle, FileText, Upload, Camera, Clipboard, Download, Award, Eye, Clock, RefreshCw, Zap } from 'lucide-react';
import { motion } from 'framer-motion';

const ICON_MAP = {
  upload: Upload, search: Search, check: CheckCircle, shield: Shield,
  'file-text': FileText, camera: Camera, clipboard: Clipboard,
  download: Download, award: Award, eye: Eye, clock: Clock,
  refresh: RefreshCw, zap: Zap,
};

export default function TrustStripSection({ section }) {
  const { title, subtitle, data = {} } = section;
  const steps = data.steps || [];
  if (steps.length === 0) return null;

  return (
    <section className="py-16 sm:py-20" data-testid="section-trust-strip">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        >
          {subtitle && <p className="text-xs uppercase tracking-[0.16em] text-muted-foreground mb-2">{subtitle}</p>}
          {title && <h2 className="font-display text-2xl sm:text-3xl font-medium tracking-[-0.015em] text-ink mb-10">{title}</h2>}
        </motion.div>
        <div className={`grid gap-6 ${
          steps.length <= 3 ? 'grid-cols-1 sm:grid-cols-3' :
          'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
        }`}>
          {steps.map((step, i) => {
            const Icon = ICON_MAP[step.icon] || Shield;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 8 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-40px' }}
                transition={{ duration: 0.35, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              >
                <Card className="bg-white border-stone/50 h-full overflow-hidden">
                  {step.image && (
                    <div className="h-28 overflow-hidden bg-stone/10">
                      <img src={step.image} alt={step.title} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  )}
                  <CardContent className="p-5">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="h-8 w-8 rounded-full flex items-center justify-center" style={{ background: 'hsl(var(--bg-paper-2))' }}>
                        <Icon className="h-4 w-4 text-ink" />
                      </div>
                    </div>
                    <h3 className="text-sm font-semibold text-ink mb-1">{step.title}</h3>
                    <p className="text-xs text-muted-foreground leading-relaxed">{step.description}</p>
                  </CardContent>
                </Card>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
